// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"782":"62ef46fd","8481":"b8b1d061","8793":"edfc152b"}[chunkId] + ".chunk.css";
};